import { parse, stringify } from 'query-string';
export const getQueryParams = (queryString) => {
    const str = queryString !== null && queryString !== void 0 ? queryString : window === null || window === void 0 ? void 0 : window.location.search;
    return parse(str);
};
export const getQueryParam = (name, queryString) => {
    const params = getQueryParams(queryString);
    return params[name];
};
export const toQueryString = (obj) => {
    return stringify(obj);
};
export const removeQueryParams = (location) => {
    var _a;
    try {
        const pathname = (_a = location === null || location === void 0 ? void 0 : location.pathname) !== null && _a !== void 0 ? _a : window === null || window === void 0 ? void 0 : window.location.pathname;
        window === null || window === void 0 ? void 0 : window.history.pushState({}, '', pathname);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
};
export const removeQueryParam = (paramKey, location) => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [paramKey]: strippedParam, ...params } = getQueryParams(location === null || location === void 0 ? void 0 : location.search);
    const filteredQueryString = toQueryString(params);
    const filteredSearch = filteredQueryString.length ? `?${filteredQueryString}` : '';
    try {
        const pathname = (_a = location === null || location === void 0 ? void 0 : location.pathname) !== null && _a !== void 0 ? _a : window === null || window === void 0 ? void 0 : window.location.pathname;
        window === null || window === void 0 ? void 0 : window.history.pushState({}, '', pathname + filteredSearch);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
};
//# sourceMappingURL=query.js.map